import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as outcomes from '../../../../outcomes'
import * as assignee from '../assignee'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: assignee.RESOURCE.payload.dimension.partialId,
      partialId: assignee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Outcome that the employee is being assigned to',
    isOptional: false,
    name: 'Outcome',
    partialId: PartialId.Standard.create('outcome'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(outcomes.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
